import Icon from '../components/Icon.vue'

Icon.register({
  'sort-amount-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M4.7 116.7L84.7 36.7C90.9 30.4 101.1 30.4 107.3 36.7L187.3 116.7C197.4 126.8 190.2 144 176 144H128V464C128 472.8 120.8 480 112 480H80C71.2 480 64 472.8 64 464V144H16C1.8 144-5.3 126.7 4.7 116.7zM240 96H496C504.8 96 512 88.8 512 80V48C512 39.2 504.8 32 496 32H240C231.2 32 224 39.2 224 48V80C224 88.8 231.2 96 240 96zM224 208V176C224 167.2 231.2 160 240 160H432C440.8 160 448 167.2 448 176V208C448 216.8 440.8 224 432 224H240C231.2 224 224 216.8 224 208zM224 464V432C224 423.2 231.2 416 240 416H304C312.8 416 320 423.2 320 432V464C320 472.8 312.8 480 304 480H240C231.2 480 224 472.8 224 464zM224 336V304C224 295.2 231.2 288 240 288H368C376.8 288 384 295.2 384 304V336C384 344.8 376.8 352 368 352H240C231.2 352 224 344.8 224 336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-amount-up.js
// module id = p2ZZ
// module chunks = 144